import { Button, StyledText, Input } from '@clickcease/cc-client-components-lib'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useConnectGoogleAccountId } from '../../../../../api/connectGoogleAccount'
import { useConnectGoogleAccountSSO } from '../../../../../api/connectGoogleAccountSSO'
import { getSsoCode } from '../../../../../api/getGoogleSsoCode'
import { useGetPlatforms } from '../../../../../api/getPlatforms'
import { GOOGLE_CONNECTION_TYPES, PLATFORMS } from '../../../../../models'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { removeSpecialCharacters } from '../../../../../../../utils/string'

import { ConnectionOptions } from '../../../../common/ConnectionOptions/ConnectionOptions'
import { ConnectionOption } from '../../../../common/ConnectionOptions/ConnectionOptions.styled'
import { PlatformConnectOption } from '../../../../common/ConnectionOptions/PlatformConnectOption'

import { MccMiddleTextMargins, MccFormContainer } from './ConnectAccount.styled'

export const ConnectAccount = ({
  submitPlatformId,
  onClose,
}: {
  submitPlatformId: (id: number, withAccess?: boolean) => void
  onClose: () => void
}) => {
  const { t } = useTranslation('PMPlatforms')
  const [idInput, setIdInput] = useState('')
  const [ssoCode, setSsoCode] = useState('')
  const { businessEmail } = useUserStore()
  const { data: platforms } = useGetPlatforms({})
  const { refetch, isFetching } = useConnectGoogleAccountId({
    mccAccountId: removeSpecialCharacters(idInput),
    config: {
      enabled: false,
      onSuccess: (data) => {
        if (!(data instanceof Error) && data.id) {
          submitPlatformId(data.id)
        }
      },
    },
  })

  const { isFetching: isFetchingSSO } = useConnectGoogleAccountSSO({
    ssoCode: ssoCode,
    config: {
      enabled: !!ssoCode,
      onSuccess: (data) => {
        if (data.id) submitPlatformId(data.id, true)
      },
    },
  })

  const isMCC = platforms?.some((p) => p.connectionType === GOOGLE_CONNECTION_TYPES.MCC)

  const onConnectSSO = (code: string) => {
    setSsoCode(code)
  }

  const onConnectPlatform = async () => {
    await refetch()
  }

  const GoogleMagicButton = () => {
    getSsoCode(onConnectSSO)
  }

  return (
    <ConnectionOptions onClose={onClose} isBusinessAccount={businessEmail}>
      {/* If user have at least one MCC account connectd - SSO is forbidden */}
      {!isMCC && (
        <PlatformConnectOption
          platform={PLATFORMS.GOOGLE}
          title={t('google-connection-wizard.connect-google-button')}
          description={t('google-connection-wizard.sso-explainer')}
          onClick={GoogleMagicButton}
        />
      )}
      {/* MCC */}
      {businessEmail && (
        <ConnectionOption>
          <StyledText variant={'largeBold'}>
            {t('google-connection-wizard.link-manually')}
          </StyledText>
          <MccMiddleTextMargins>
            <StyledText variant={'baseLight'} css={{ width: '250px', textAlign: 'center' }}>
              {t('google-connection-wizard.add-id')}
            </StyledText>
          </MccMiddleTextMargins>
          <MccFormContainer>
            <Input
              value={idInput}
              onChange={(e) => setIdInput(e.target.value)}
              placeholder="Eg: 111-222-3333"
              css={{ width: '140px', marginRight: '16px' }}
            />
            <Button disabled={!idInput.length} onClick={onConnectPlatform}>
              {isFetching || isFetchingSSO
                ? 'Sending...'
                : t('google-connection-wizard.connect-button')}
            </Button>
          </MccFormContainer>
        </ConnectionOption>
      )}
    </ConnectionOptions>
  )
}
